<template>
<div class=WordSection1>

<p class=MsoNormal align=center style='text-align:center'><a
name="_Toc528332943"><b><span style='font-size:16.0pt;line-height:150%;
font-family:"Calibri","sans-serif"'>LA VALUTAZIONE FORMATIVA</span></b></a></p>

<p class=MsoNormal><span style='font-size:8.0pt;line-height:150%;font-family:
"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>E.C.Fo.P. ritiene i momenti di valutazione
fondamentali per monitorare e arricchire continuamente i processi formativi.</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>La valutazione non è da intendersi come una
valutazione della persona, ma la rilevazione dell’incremento di conoscenze,
abilità, competenze e maturità personale. Il suo valore è formativo perché
aiuta ad aumentare la consapevolezza dei propri punti di forza e di debolezza,
migliorando così la capacità di autovalutazione dei corsisti.</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>Allo stesso tempo, fornisce indicazioni
utili ai formatori sull’efficacia della propria modalità formativa e favorisce 
il processo di autovalutazione dell’intera organizzazione riguardo al proprio
operato.</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>La <b>SCHEDA DI VALUTAZIONE</b> (un
documento più articolato e complesso della <i>pagella</i> di un tempo) è
composta da più parti che hanno significati e caratteristiche diverse e
complementari.</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoListParagraphCxSpFirst style='text-indent:-18.0pt'><span
style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-family:"Calibri","sans-serif"'>VALUTAZIONI
DISCIPLINARI</span></b></p>

<p class=MsoListParagraphCxSpLast><span style='font-family:"Calibri","sans-serif"'>E’
la parte in cui, in un certo senso, viene comunicata la “misura” del livello di
acquisizione di conoscenze/abilità di ciascuna disciplina, espressa in
centesimi.</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:10.0pt;
font-family:"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoListParagraphCxSpFirst style='text-indent:-18.0pt'><span
style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-family:"Calibri","sans-serif"'>MODALITA’
RELAZIONALE IN AMBITO FORMATIVO</span></b></p>

<p class=MsoListParagraphCxSpLast><span style='font-family:"Calibri","sans-serif"'>Valuta
un aspetto non cognitivo, ma fondamentale per l’approccio al mondo del lavoro. Tiene
conto dei giudizi espressi da tutti i formatori del corso e si delinea
attraverso una serie di descrittori della relazione tra pari e con i formatori,
della partecipazione alle attività formative e del rispetto di quanto previsto
nel regolamento .</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:10.0pt;
font-family:"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoListParagraphCxSpFirst style='text-indent:-18.0pt'><span
style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-family:"Calibri","sans-serif"'>VALUTAZIONE
STAGE (dal II anno)</span></b></p>

<p class=MsoListParagraphCxSpLast><span style='font-family:"Calibri","sans-serif"'>Riporta
la valutazione dell’esperienza di alternanza data dal tutor aziendale insieme
al tutor formativo rispetto al raggiungimento degli obiettivi relazionali e
professionali definiti nel piano formativo di ciascun corsista.</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:10.0pt;
font-family:"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoListParagraphCxSpFirst style='text-indent:-18.0pt'><span
style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-family:"Calibri","sans-serif"'>PUNTI PATENTE
(solo per la sede di Monza)</span></b></p>

<p class=MsoListParagraphCxSpMiddle><span style='font-family:"Calibri","sans-serif"'>Attraverso
un numero esprime la motivazione al rispetto delle regole e lo sviluppo di
atteggiamenti personali virtuosi e partecipativi utili nel mondo del lavoro e
nella società.  Come indicato nel progetto, la dotazione iniziale di punti può
subire incrementi o decrementi in funzione della frequenza, della
partecipazione a manifestazioni orientative/campus extra-formative, della
gestione del materiale di laboratorio, del rispetto del regolamento del centro.</span></p>

<p class=MsoListParagraphCxSpLast><span style='font-family:"Calibri","sans-serif"'>Al
termine dell’anno formativo il punteggio conseguito verrà commutato in punti
aggiuntivi o diminutivi  alla  valutazione  complessiva media  nella  scheda di
valutazione secondo una tabella definita.</span></p>

<p class=MsoNormal style='line-height:normal'><span style='font-size:10.0pt;
font-family:"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoListParagraphCxSpFirst style='text-indent:-18.0pt'><span
style='font-family:Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span style='font-family:"Calibri","sans-serif"'>VALUTAZIONE
COMPLESSIVA MEDIA</span></b></p>

<p class=MsoListParagraphCxSpLast><span style='font-family:"Calibri","sans-serif"'>Espressa
in centesimi, tiene conto della valutazione didattico-formativa (valutazione
disciplinare e stage) in misura dell'80% e della modalità relazione in ambito
formativo in misura del 20% e, per i corsisti della sede di Monza che
partecipano al progetto, dell’incremento o decremento associato al valore
corrispondente ai punti patente raggiunti. </span></p>

<p class=MsoNormal style='line-height:15.0pt'><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoNormal style='line-height:15.0pt'><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>&nbsp;</span></p>

<p class=MsoNormal style='line-height:15.0pt'><i><span style='font-size:12.0pt;
font-family:"Calibri","sans-serif"'>La valutazione formativa è pertanto una
comunicazione sull’andamento del percorso e deve intendersi come una “bussola”
che orienta ciascun corsista sul cammino di crescita e formazione personale e professionale,
per capire se si sta partecipando proficuamente alla formazione  oppure è
necessario modificare il proprio modo di porsi e affrontarla. In questo caso è
fondamentale che il genitore/tutore si confronti con i formatori per realizzare
la continuità formativa assunta come finalità del progetto educativo dell’Ente.</span></i></p>

<p class=MsoNormal><span style='font-size:12.0pt;line-height:150%;font-family:
"Calibri","sans-serif"'>&nbsp;</span></p>

</div>

</template>

<script>
export default {};
</script>

<style>
</style>
